/** @format */

"use client";

import Image from "next/image";
import Link from "next/link";
import React, { useEffect, useState } from "react";
import MailIcon from "@mui/icons-material/Mail";
import bannerImg from "@/Helper/images/contact_us_banner.svg";
import { apiService } from "@/services/api.services";
import CallIcon from "@mui/icons-material/Call";
import BusinessIcon from "@mui/icons-material/Business";
import "./page.css"


const ContactUs = () => {
  const [details, setDetails] = useState(null);

  useEffect(() => {
    async function fetchFooterData() {
      try {
        const resp = await apiService.getAllUtilityData();
        if (resp.status === 200) {
          setDetails(resp.data?.data?.attributes);
        } else {
          throw new Error("Failed to fetch data"); 
        }
      } catch (err) {
        console.log(err);
      }
    }

    fetchFooterData();
  }, []);

  const embedUrl = `https://www.youtube.com/watch?v=IbciQzUbp9s`;

  return (
    <>
     <section className="banner_bg1 case_bannerbg contactbgbanner">
        <div className="container banner_container1">
          <div className="banner_inner">
            <div className="banner_left banner_leftfullcenter">
              <h1 className="banner_heading1">Consult with our sales team</h1>
              <p className="banner_text1">Get in touch by phone or message for <br/>more information at <a href="tel:+12106669190" className='contact_phone'> +91 9488 54 8833</a>
              </p>
            </div>
          </div>
        </div>
      </section>
      </>
  );
};

export default ContactUs;
